















































































































































































































































import { Component, Prop, Vue, Mixins, Watch, Emit } from 'vue-property-decorator';
import multiselect from 'vue-multiselect';
import Combobox from '../../core/components/Combobox.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import PlusEyeButtons from '../../core/components/PlusEyeButtons.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import TableArrows from '../../core/components/TableArrows.vue';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import ModalInsuranceCompany from '../../insurance/components/ModalInsuranceCompany.vue';

import {
    // AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
    // StoreHelper,
    // NotificationStoreHelper
} from '../../core/mixins';
import {
    splitStringByIndex,
    getCompanyItemById,
    addItemsToListIfAreNotAdded,
    removeItemsFromList,
    getIdsFromList,
    matchedIndexIdInArray,
    sortObjectByPropertyName,
    goToUrl,
    PRIVILEGE_KEYS,
    isNullOrEmpty
} from '../../core/utils';
import { InsuranceServices } from '../api/InsuranceServices';
import { getUrlFarmingDetail } from '../utils';
import { HarvestRanchListFilters } from '../api/models';
import Axios, { CancelTokenSource } from 'axios';
import { sortTypes } from '../../../features/core/models/Table';

@Component({
    components: {
        multiselect,
        Combobox,
        Button,
        Input,
        DatePickerRange,
        SimpleTable,
        TableArrows,
        PlusEyeButtons,
        DeleteConfirmation,
        ModalInsuranceCompany
    }
})
export default class ModalInsuranceHarvest extends Mixins(
    NotificationStoreHelper,
    CompanyStoreHelper,
    RootStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({ default: false }) editing: boolean;
    @Prop({
        default() {
            return [];
        }
    })
    cropTypeOptions: Array<object>;
    @Prop({ default: {} }) patchData: object;
    @Prop({
        default() {
            return [];
        }
    })
    optionsInsuranceCompany: any;
    @Prop({
        default() {
            return [];
        }
    })
    optionsFarmings: Array<object>;

    modalTitle: string = '';
    fileName: string = '';
    startYear: string = '';
    endYear: string = '';
    harvestName: string = '';
    searchAvailableFarmings: string = '';

    //selectors
    insuranceCompanySelected: any = null;
    cropTypeSelected: any = null;
    harvestSelected: any = null;
    securedCompanySelected: any = null;

    //selectors reset values
    insuranceCompanyRV: boolean = false;
    cropTypeRV: boolean = false;
    harvestRv: boolean = false;
    companyRv: boolean = false;

    loadingAvailableFarmings: boolean = false;
    loadingEditInsuranceCompany: boolean = false;
    activeFarming: boolean = true;

    //selector options
    insuranceCompanyOptions: Array<object> = [];
    securedCompanies: Array<object> = [];

    itemsAvailableFarmings: Array<object> = [];
    itemsAvailableFarmingsSelected: Array<object> = [];
    itemsSelectedFarmings: Array<object> = [];
    itemsAvailableCheckedFarmings: Array<object> = [];
    items: any = [
        {
            id: 1,
            company: 'Empresa 1',
            description: 'Zafra 1'
        },
        {
            id: 2,
            company: 'Empresa 1',
            description: 'Zafra 2'
        }
    ];

    headers: any = [
        {
            text: 'Empresa',
            value: 'company__name',
            sortable: true
        },
        {
            text: 'Descripción',
            value: 'name',
            sortable: true
        },
        {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            sortable: true
        }
    ];

    headersSelectedFarmings: any = [
        {
            text: 'Empresa',
            value: 'company__name',
            sortable: true
        },
        {
            text: 'Descripción',
            value: 'name',
            sortable: true
        },
        {
            text: 'Alertas',
            value: 'alerts',
            align: 'center'
        },
        {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            sortable: true
        }
    ];

    dateRangeSelected: any = [];
    allAvailableFarmings: Array<object> = [];
    counter: number = 0;

    //delete modal
    confirmationDelete: boolean = false;
    deleteModalTitle: string = 'Eliminar';
    pendingRequestInsuranceFarming: boolean = false;

    visibleModalInsuranceCompany: boolean = false;
    editCompanyHarvest: boolean = false;
    editInsuranceCompany: boolean = false;

    patchCompanyFarming: object = {};
    patchInsuranceCompany: object = {};

    invalidSelectedFarming: number = 0;

    searchParams: HarvestRanchListFilters = {
        page: 1,
        page_size: 10,
    };
    searchRanchList: string = '';
    savedQueries: string[] = [];
    requestTokenInstance: CancelTokenSource = Axios.CancelToken.source();
    paginationTotalPages: number = 0;
    paginationTotalRows: number = 0;
    

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    @Watch('cropTypeSelected')
    @Watch('dateRangeSelected')
    @Watch('insuranceCompanySelected')
    observableHarvestFields(){
        if(!this.editing){
            this.preselectName();
        }
    }

    updateInsuranceCompanySelected(value) {
        if(value == null){
            if(this.searchParams.hasOwnProperty('insurance_company')){
                delete this.searchParams.insurance_company;
            }
        }else{
            this.searchParams.insurance_company = value['id'];
        }
        this.findAvailableFarmings();
        this.insuranceCompanySelected = value;
    }
    updateInsuranceCompanyRV(value) {
        this.insuranceCompanyRV = value;
    }
    updateCropTypeSelected(value) {
        this.cropTypeSelected = value;
    }
    updateCropTypeRV(value) {
        this.cropTypeRV = value;
    }
    updateHarvestSelected(value) {
        this.harvestSelected = value;
    }
    updateHarvestRV(value) {
        this.harvestRv = value;
    }
    updateHarvestName(value) {
        if (value == null) {
            value = '';
        }
        this.harvestName = value;
    }
    updateSecuredCompanySelected(value) {
        if(value == null){
            if(this.searchParams.hasOwnProperty('companies')){
                delete this.searchParams['companies'];
            }
        }else{
            this.searchParams['companies'] = [value['id']];
        }
        this.securedCompanySelected = value;
        this.findAvailableFarmings();
    }
    updateSecuredCompanyRV(value) {
        this.companyRv = value;
    }

    changeDateRange(value) {
        this.dateRangeSelected = value;
        this.startYear = '';
        this.endYear = '';
        this.startYear = splitStringByIndex(value[0], 0, 4);
        this.endYear = splitStringByIndex(value[1], 0, 4);
    }

    addFarmingToSelectedOnes() {
        this.itemsSelectedFarmings = addItemsToListIfAreNotAdded(
            this.itemsSelectedFarmings,
            this.itemsAvailableFarmingsSelected,
            'id'
        );
        this.itemsAvailableFarmingsSelected = [];
        this.checkInsuranceFarmingsSelected();
    }

    removeFarmingSelected() {
        this.updateSelectedFarmings(this.itemsAvailableCheckedFarmings);
        this.itemsAvailableCheckedFarmings = [];
        this.checkInsuranceFarmingsSelected();
    }

    updateSelectedFarmings(newItems) {
        this.itemsSelectedFarmings = removeItemsFromList(this.itemsSelectedFarmings, newItems, 'id');
    }

    mounted() {
        this.setModalTitle();

        this.$nextTick(() => {
            this.loadPatchData();
            this.updateAvailableFarmingList();
        });
    }

    loadPatchData() {
        if (this.editing) {
            this.activeFarming = this.patchData['active']; //active

            this.updateHarvestName(this.patchData['name']);

            //date range
            this.dateRangeSelected = [this.patchData['start_date'], this.patchData['end_date']];

            //tipo cultivo
            let indexCropType = matchedIndexIdInArray(this.cropTypeOptions, this.patchData['harvest_type'].toString());
            if (indexCropType !== -1) {
                this.updateCropTypeSelected(this.cropTypeOptions[indexCropType]);
            }

            //zafras seleccionadas
            this.itemsSelectedFarmings = this.patchData['company_farmings'].map(v => ({
                ...v,
                company__name: v['company']['name'],
                insurance_farming: this.patchData['insurance_farming__id']
            }));

            //empresa aseguradora
            let insuranceCompanies = this.$_getInsuranceProperties['insurance_companies'];
            let indexInsuranceCompany = matchedIndexIdInArray(
                insuranceCompanies,
                this.patchData['insurance_company']['id']
            );
            if (indexInsuranceCompany !== -1) {
                this.updateInsuranceCompanySelected(insuranceCompanies[indexInsuranceCompany]);
            }
        }
    }

    updateAvailableFarmingSelectedRows(rows) {
        this.itemsAvailableFarmingsSelected = rows;
    }

    updateFarmingsToRemove(rows) {
        this.itemsAvailableCheckedFarmings = rows;
    }

    excludeFarmingSelected(item) {
        this.updateSelectedFarmings([item]);
        this.checkInsuranceFarmingsSelected();
    }

    updateSearchAvailableFarmings(value) {
        this.searchAvailableFarmings = value;
        this.itemsAvailableFarmingsSelected = [];
        this.searchRanchList = value;
        if(isNullOrEmpty(value)){
            delete this.searchParams.query;
        }else{
            this.searchParams.query = value;
        }
        this.searchParams.page = 1
        this.findAvailableFarmings();
    }

    setModalTitle() {
        let title = this.editing ? 'Modificar ' : 'Crear ';
        title += 'Zafra de Aseguradora';
        if (this.editing) {
            title += ': <b>' + this.patchData['name'] + '</b>';
        }
        this.modalTitle = title;
    }

    getSelectedCompany(value) {
        return this.insuranceCompanySelected !== null ? this.insuranceCompanySelected[value] : null;
    }

    getSelectedCropType(value) {
        return this.cropTypeSelected !== null ? this.cropTypeSelected[value] : null;
    }

    get getSelectedStartYear() {
        return this.startYear !== null ? this.startYear : null;
    }

    preselectName(){
        this.harvestName = this.getFileName;
    }

    get getFileName() {
        return (
            this.getSelectedCompany('name') +
            ' - ' +
            this.getSelectedCropType('value') +
            ' - ' +
            this.getSelectedStartYear
        );
    }

    @Watch('insuranceCompanySelected')
    observableInsuranceCompanyChange(value) {
        //empresa asegurada
        this.setCompanyOptions(value);
        this.updateSecuredCompanySelected(null);
    }

    showAllAvailableFarmings() {
        this.assignAvailableFarmings(this.allAvailableFarmings);
    }

    assignAvailableFarmings(items) {
        
    }

    checkInsuranceFarmingsSelected() {
        this.invalidSelectedFarming = 0;
        for (let index = 0; index < this.itemsSelectedFarmings.length; index++) {
            let msgs: string[] = [];
            let farming = this.itemsSelectedFarmings[index];

            if (this.editing) {
                //si la zafra aseguradora asignada es distinta a la que estoy patcheando
                //mostrar alerta
                if (farming['insurance_farming__id'] !== this.patchData['insurance_farming__id']) {
                    msgs.push('Ésta zafra ya tiene una aseguradora asignada' + '<br>');
                    this.invalidSelectedFarming++;
                }
            } else {
                let indexFarmingCompanyIdInSecuredCompanies = this.securedCompanies.findIndex(
                    item => item['id'] === farming['company__id']
                );
                if (indexFarmingCompanyIdInSecuredCompanies == -1) {
                    msgs.push('Ésta zafra no pertenece a la Empresa Aseguradora seleccionada' + '<br>');
                    this.invalidSelectedFarming++;
                }

                if (farming['insurance_farming__id'] !== null) {
                    msgs.push('Ésta zafra ya tiene una aseguradora asignada');
                    this.invalidSelectedFarming++;
                }
            }
            this.$set(farming, 'alerts', { msgs: msgs });
        }
    }

    setCompanyOptions(insuranceSelected) {
        // this.loadingOptionsCompany = true;
        let companyOptions: Array<object> = [];
        if (insuranceSelected !== null) {
            let companyIndex = this.optionsInsuranceCompany.findIndex(
                item => item['company'] === insuranceSelected['company']
            );

            if (companyIndex !== -1) {
                companyOptions = this.optionsInsuranceCompany[companyIndex]['secured_companies'];
            }
        } else {
            this.updateSecuredCompanySelected(null);
        }
        this.securedCompanies = companyOptions;
        // this.loadingOptionsCompany = false;
    }

    getData() {
        let data = {
            insurance_company: this.insuranceCompanySelected['id'],
            start_date: this.dateRangeSelected[0],
            end_date: this.dateRangeSelected[1],
            active: this.activeFarming,
            harvest_type: this.cropTypeSelected['id'],
            company_farming_list: getIdsFromList(this.itemsSelectedFarmings),
            name: this.harvestName
        };
        if (this.editing) {
            this.$set(data, 'id', this.patchData['id']);
        }
        return data;
    }

    submitFarming() {
        // console.log("submit farming", formData);
        let formData = this.getData();
        if (!this.editing) {
            this.postFarming(formData);
        } else {
            this.patchFarming(formData);
        }
    }

    addNewInsuranceFarmingToPropertiesList(newInsuranceFarmingId: number, newRow:object){
        let insuranceFarmingListFromProperties = JSON.parse(JSON.stringify(this.$_getInsuranceProperties['insurance_farmings']));
        let existInList = insuranceFarmingListFromProperties.findIndex(item => item['id'] == newInsuranceFarmingId);

        if(existInList == -1){
            insuranceFarmingListFromProperties.push(newRow);
            //add new insurance farming to properties list
            this.$_setInsuranceProperties({
                ...this.$_getInsuranceProperties,
                insurance_farmings: insuranceFarmingListFromProperties
            });
        }
    }

    postFarming(formData) {
        this.showLoadingDialog('Creando Zafra de Aseguradora');
        InsuranceServices.postInsuranceFarming(formData)
            .then(res => {
                this.$_successLoadingDialog({
                    response: res
                });
                this.addNewInsuranceFarmingToPropertiesList(
                    res['new_insurance_farming']['id'],
                    res['new_insurance_farming']
                )
               
                this.closeModal();
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo crear la Zafra de Aseguradora');
            });
    }

    patchFarming(formData) {
        this.showLoadingDialog('Modificando Zafra de Aseguradora');
        InsuranceServices.patchInsuranceFarming(formData)
            .then(res => {
                this.$_successLoadingDialog({
                    response: res['data']
                });

                let updatedInsuranceFarming = res['data']['insurance_farming'];
                //update properties
                let updatedProperties = JSON.parse(JSON.stringify(this.$_getInsuranceProperties));
                let updatedInsuranceFarmings = updatedProperties['insurance_farmings'];
                let indexInsuranceFarmingInProperties = matchedIndexIdInArray(
                    updatedInsuranceFarmings,
                    updatedInsuranceFarming['id']
                );

                if (indexInsuranceFarmingInProperties !== -1) {
                    updatedProperties['insurance_farmings'][
                        indexInsuranceFarmingInProperties
                    ] = updatedInsuranceFarming;
                    this.$_setInsuranceProperties(updatedProperties);
                }
                setTimeout(() => {
                    this.$emit('update-insurance-farming', updatedInsuranceFarming);
                }, 100);
                this.closeModal();
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo modificar la Zafra de Aseguradora');
            });
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }


    deleteAction(value) {
        this.confirmationDelete = false;
        if (value) {
            this.showLoadingDialog('Eliminando Zafra de Aseguradora');
            InsuranceServices.deleteInsuranceFarming(this.patchData['id'])
                .then(response => {
                    let msg = '';
                    if (response && response.data && response.data.message) {
                        msg = response.data.message;
                    } else {
                        msg = 'Zafra de aseguradora eliminada con éxito';
                    }
                    this.showSuccessLoadingDialog(response.data, msg);
                    let updatedProperties = JSON.parse(JSON.stringify(this.$_getInsuranceProperties));
                    let propertiesInsuranceFarmings = updatedProperties['insurance_farmings'];
                    let checkIfExistPreviousIndexWithSameId = matchedIndexIdInArray(
                        propertiesInsuranceFarmings,
                        this.patchData['id']
                    );
                    if (checkIfExistPreviousIndexWithSameId !== -1) {
                        propertiesInsuranceFarmings.splice(checkIfExistPreviousIndexWithSameId, 1);
                        this.$_setInsuranceProperties(updatedProperties);
                    }
                    this.$emit('delete-action');
                })
                .catch(err => {
                    this.showCatchLoadingDialog(err, 'No se pudo eliminar la Zafra de Aseguradora');
                });
            // this.closeModal();
        }
    }

    deleteFarming() {
        this.deleteModalTitle = 'Eliminar Zafra de Aseguradora';
        this.confirmationDelete = true;
    }

    visibilityModalInsuranceCompany(value) {
        this.visibleModalInsuranceCompany = value;
    }

    createCompanyHarvest() {
       goToUrl(getUrlFarmingDetail(null))
    }

    modifyInsuranceCompany() {
        this.loadingEditInsuranceCompany = true;
        InsuranceServices.getInsuranceCompany(this.insuranceCompanySelected['id'])
            .then(res => {
                this.patchInsuranceCompany = res;
                this.editInsuranceCompany = true;
                this.loadingEditInsuranceCompany = false;
                this.visibilityModalInsuranceCompany(true);
            })
            .catch(err => {
                this.loadingEditInsuranceCompany = false;
            });
    }

    modifyCompanyHarvest(item) {
        goToUrl(getUrlFarmingDetail(item['id']))
    }

    selectNewInsuranceCompany(newCompany) {
        this.insuranceCompanySelected = newCompany;
    }

    get checkIfFormIsValid() {
        if (this.insuranceCompanySelected == null) {
            return false;
        }

        if (this.cropTypeSelected == null) {
            return false;
        }

        if (this.dateRangeSelected.length == 0) {
            return false;
        }

        if (this.invalidSelectedFarming > 0) {
            return false;
        }

        if (this.editing && this.harvestName === '') {
            return false;
        }

        return true;
    }

    addNewCompanyFarming(newItem) {
        this.findAvailableFarmings();
        this.$_successPatchRecipients('Zafra de Empresa agregada');
    }

    createNewInsuranceCompany() {
        this.editInsuranceCompany = false;
        this.patchInsuranceCompany = {};
        this.visibilityModalInsuranceCompany(true);
    }

    updateSecuredCompanies(availableInsuranceCompanies) {
        this.setCompanyOptions(this.insuranceCompanySelected);
        this.updateSecuredCompanySelected(null);
        this.updateAvailableFarmingList();
        this.checkInsuranceFarmingsSelected();
    }

    deletedInsuranceCompany() {
        this.updateInsuranceCompanySelected(null);
        this.updateSecuredCompanySelected(null);
        this.updateAvailableFarmingList();
        this.checkInsuranceFarmingsSelected();
    }

    @Emit()
    closeModal() {}

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    updatesearchParams(page, itemsPerPage){
        this.searchParams.page = page;
        this.searchParams.page_size = itemsPerPage;
        this.searchParams.query = this.searchAvailableFarmings;
        this.findAvailableFarmings();
    }


    updateTableOptions({sortBy, sortDesc, itemsPerPage, page}){
        this.searchParams.page_size = itemsPerPage;
        this.searchParams.page = page;
        if(sortBy.length ==  0){
            delete this.searchParams.sort_by;
            delete this.searchParams.sort_type;
        }else{
            let sortType = sortDesc[0] == true ? sortTypes.desc : sortTypes.asc;
            this.searchParams.sort_by = sortBy;
            this.searchParams.sort_type = sortType;
        }
        this.findAvailableFarmings();
        
    }

    findAvailableFarmings(){
        this.updateAvailableFarmingList();
    }

    updateAvailableFarmingList(){
        this.requestTokenInstance.cancel();
        this.requestTokenInstance = Axios.CancelToken.source();
        this.loadingAvailableFarmings = true;
        InsuranceServices.getFarmingList(
            this.requestTokenInstance, 
            this.searchParams
        )
        .then(res => {
            this.itemsAvailableFarmings = res.data;
            this.loadingAvailableFarmings = false;
            this.paginationTotalPages = res.totalPages;
            this.paginationTotalRows = res.count;
        })
        .catch(err => {
            if(err && err.message == 'Request canceled'){
                this.loadingAvailableFarmings = true
                return;
            }
            this.paginationTotalPages = 1;
            this.paginationTotalRows = 0;
            this.itemsAvailableFarmings = [];
            this.loadingAvailableFarmings = false;
            if(err && err.response && err.response.data){
                this.$_catchLoadingDialog({
                    response: err.response.data || {},
                    alternative_msg: 'Ocurrió un error al obtener las zafras'
                });
            }
        })
    }
}
